import React from 'react';

function NotFoundPage() {
  return (
    <div>This URL Is not valid.</div>
  )
}

export default NotFoundPage